import { LoLExaminationSection } from '../../Contexts/LoLExaminationProvider/types';

export const DEFAULT_MILESTONES = [
  {
    tags: [LoLExaminationSection.RIASEC],
    title: 'RIASEC',
    duration: 20,
  },

  {
    tags: [LoLExaminationSection.VALUE],
    title: 'VALUE',
    duration: 5,
  },

  {
    tags: [LoLExaminationSection.ACTIVITY],
    title: 'ACTIVITY',
    duration: 15,
  },
  {
    tags: [LoLExaminationSection.STRENGTH],
    title: 'STRENGTH',
    duration: 20,
  },
];
